import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShowComponent } from './show.component';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatTabsModule } from '@angular/material/tabs';
import { ReportComponent } from './tabs/report/report.component';
import { NewModule } from '../new/new.module';

@NgModule({
  declarations: [
    ShowComponent,
    ReportComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,

    FontAwesomeModule,
    MatTabsModule,
    NewModule
  ]
})
export class ShowModule { }
